import React from "react";

const GruvIcon = ({ title, ...props }) => (
  <svg
    version="1.1"
    viewBox="0 0 693.7 407"
    style={{ enableBackground: "new 0 0 693.7 407" }}
    {...props}
  >
    {title ? <title>{title}</title> : null}
    <g>
      <path
        d="M256.7,77.6c7.1-4.1,12.9-8.1,19.3-10.8c9.6-4.1,19.3-8.5,29.3-10.4c12.2-2.4,22.6,5.1,25.8,16.1
  		c3.4,11.6-1.6,22.4-13,28.3c-11.4,5.9-23.1,11.5-34.1,18c-6.7,3.9-12.8,9.1-18.7,14.2c-6.5,5.8-9.6,13.2-9.1,22.2
  		c0.4,7.8,0.2,15.7,0.1,23.6c-0.3,14.6-10.5,25.3-23.8,25.1c-13-0.2-22.8-10.8-22.9-25.3c-0.1-39.1-0.1-78.1,0-117.2
  		c0-13.7,9.4-23.8,22.2-24.5c12-0.7,22.2,8.2,24,21.3C256.5,64.2,256.4,70.3,256.7,77.6z"
      />
      <path
        d="M348.8,126.8c-0.4-14.9,6.5-24.7,17.1-26c12-1.5,21.6,6.9,22.8,19.9c0.2,2.8,0.1,5.7,0.6,8.5
  		c3.2,20.4,19.2,33,40.4,32c19.3-0.9,34-15.6,35.5-35.4c0.2-3,0.2-6.1,0.9-9.1c2.3-10,10-16.2,19.5-16c9.5,0.2,17.4,6.5,18.9,16.7
  		c2.3,15.4-1.3,30-8.2,43.7c-15.4,31-48.7,47.3-83.6,41.3c-32.7-5.6-58.7-33.4-62.7-66.9C349.3,132,349,128.5,348.8,126.8z"
      />
      <path
        d="M462.5,74.8c-10.3,0.1-18.4-7.8-18.3-18c0-10,7.7-17.8,17.7-17.9c10.1-0.2,18.5,7.9,18.5,18
  		C480.3,66.7,472.4,74.7,462.5,74.8z"
      />
      <path
        d="M411.3,56.7c0.1,10.4-7.7,18.2-18.1,18.1c-9.8-0.1-17.9-8-18-17.8c-0.1-10,8.2-18.2,18.3-18.1
  		C403.5,39,411.2,46.6,411.3,56.7z"
      />
      <path
        d="M692.9,54.1c-2.4-10-10.9-16.2-21-16.6c-11.4-0.4-19.5,4.7-23.4,15.2c-12.2,32.9-24.3,65.9-36.5,98.9
  		c-1,2.6-2.1,5.2-3.7,9.3c-1.5-3.6-2.5-5.7-3.3-7.9c-12.4-33.3-24.7-66.7-37.1-100c-4.7-12.7-17.7-18.8-30.4-14.3
  		c-11.8,4.1-18.2,17.5-14,30c15.6,46.8,31.3,93.5,47,140.2c1.6,4.9,3.2,9.8,5,15.4c-3.4,0.2-5.7,0.4-8.1,0.4
  		c-128.8,0-257.6,0-386.4,0c-8.4,0-8.4,0-8.4-8.8c0-55.9,0-111.8,0-167.6c0-2.6,0.1-5.3-0.1-7.9c-1.1-12-10.7-20.9-22.6-21.1
  		c-12.4-0.2-22.5,8.3-24,20.4c-0.3,2.1-0.4,4.3-0.7,7.5c-18.8-9.2-37.5-12.4-57-8.4c-19.8,4.1-36.1,14-48.7,29.8
  		c-21.8,27.5-25,65.5-5.9,94.3c27.7,41.7,66.2,48.8,112,31c0,8.4-0.2,16.4,0.1,24.4c0.2,4.9-1.6,6.6-6.4,6.5c-12-0.2-24-0.2-36,0
  		c-54.8,1-93.3,52.3-79.1,105.1c9.3,34.5,42.5,60.2,79,61.1c40.5,1,71.8-20.7,83.2-57.7c5.3-17.1,6.2-34.7,6.2-52.5c0-8.9,0-9,8.8-9
  		c95.8,0,191.7,0,287.5,0c44.7,0,89.5,0,134.2,0c15,0,24-5.9,28.7-20.4c19.9-61.2,40.6-122.1,60.8-183.2
  		C694.1,63.9,694,58.6,692.9,54.1z M84.3,349.7c-23.2-0.1-41.8-18.9-41.7-42.2c0.1-23.1,19.1-41.9,42.2-41.8
  		c23,0.2,42.1,19.4,41.9,42.3C126.5,331.1,107.5,349.8,84.3,349.7z M84.7,162.4c-23.3-0.1-41.9-18.8-41.8-42.1
  		C42.9,97.1,61.8,78.3,85,78.4c23,0.1,42.1,19.2,42,42.2C126.9,143.6,107.8,162.4,84.7,162.4z"
      />
    </g>
  </svg>
);

export default GruvIcon;
